import { Component, DoCheck, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VALIDATION_SERVICE, IValidationService } from '../../core/interfaces';
import { ValidationLevel } from '../../core/types';

/**
 * Zeigt einen Kommentar-Indikator (rote/gelbe Unterstreichung) an,
 * wenn für eines der angegebenen Felder ein Kommentar existiert.
 *
 * Verwendung: <wd-comment-indicator [fields]="['Feld1', 'Feld2*']">{{inhalt}}</wd-comment-indicator>
 * Mit * am Ende wird Präfix-Matching verwendet (z.B. 'Hauptbodenform*' matcht 'Hauptbodenform[0]', 'Hauptbodenform[1]', etc.)
 */
@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'wd-comment-indicator',
    template: `<span class="comment-indicator" [ngClass]="currentClass"><ng-content></ng-content></span>`,
    styles: [`
        .comment-indicator {
            display: inline-block;
        }
        .comment-indicator.danger {
            border-bottom: 3px solid #c82333;
        }
        .comment-indicator.warning {
            border-bottom: 3px solid #e0a800;
        }
    `],
})
export class CommentIndicatorComponent implements DoCheck {
    @Input() fields: string[] = [];
    currentClass = '';

    private vs: IValidationService = inject(VALIDATION_SERVICE);

    ngDoCheck(): void {
        this.currentClass = this.indicatorClass();
    }

    private indicatorClass(): string {
        let maxSeverity = ValidationLevel.ok;

        for (const field of this.fields) {
            // Präfix-Matching mit * am Ende
            if (field.endsWith('*')) {
                const prefix = field.slice(0, -1);
                const severity = this.vs.getMaxCommentSeverityByPrefix(prefix);
                if (severity > maxSeverity) {
                    maxSeverity = severity;
                }
            } else {
                const comments = this.vs.hasComments(field);
                if (comments && !comments.resolved) {
                    if (comments.type > maxSeverity) {
                        maxSeverity = comments.type;
                    }
                }
            }
        }

        switch (maxSeverity) {
            case ValidationLevel.danger: return 'danger';
            case ValidationLevel.warning: return 'warning';
            default: return '';
        }
    }
}
